import type { RootState } from 'store'
import type { ActionTree } from 'vuex'
import { ClientService } from '../service'
import { GET_LIST_CLIENTS, GET_CLIENT, type ClientState } from './types'
import orderBy from 'lodash/orderBy'
import type { IClientParams } from 'interfaces'

const clientService = new ClientService()

export const actions: ActionTree<ClientState, RootState> = {
  actGetListClients({ commit }, params: object) {
    return clientService.getListClients(params).then((clients) => {
      const transform = orderBy(clients, [(a) => new Date(a.updatedAt)], ['desc'])
      commit(GET_LIST_CLIENTS, transform)

      return transform
    })
  },
  actCreateClient(_, params: IClientParams) {
    return clientService.createClient(params)
  },
  actUpdateClient(_, params: IClientParams) {
    return clientService.updateClient(params)
  },
  actDeleteClient(_, params: IClientParams) {
    return clientService.deleteClient(params)
  },
  actGetClient({ commit }, params: IClientParams) {
    return clientService.getClient(params).then((client) => commit(GET_CLIENT, client))
  },
}
